// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentMedicalPayor {
    static getAttributeTypeMap() {
        return BasicEnrollmentMedicalPayor.attributeTypeMap;
    }
}
BasicEnrollmentMedicalPayor.discriminator = undefined;
BasicEnrollmentMedicalPayor.additionalProperties = false;
BasicEnrollmentMedicalPayor.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberExtension",
        "baseName": "phoneNumberExtension",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
    {
        "name": "faxNumberExtension",
        "baseName": "faxNumberExtension",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "BasicEnrollmentAddress"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "policyNumber",
        "baseName": "policyNumber",
        "type": "string"
    },
    {
        "name": "planEffectiveDate",
        "baseName": "planEffectiveDate",
        "type": "Date"
    },
    {
        "name": "planExpirationDate",
        "baseName": "planExpirationDate",
        "type": "Date"
    },
    {
        "name": "planTerminationDate",
        "baseName": "planTerminationDate",
        "type": "Date"
    },
    {
        "name": "policyName",
        "baseName": "policyName",
        "type": "string"
    },
    {
        "name": "policyHolderFirstName",
        "baseName": "policyHolderFirstName",
        "type": "string"
    },
    {
        "name": "policyHolderLastName",
        "baseName": "policyHolderLastName",
        "type": "string"
    },
    {
        "name": "relationshipToPatient",
        "baseName": "relationshipToPatient",
        "type": "RoleType"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    },
];
//# sourceMappingURL=basicEnrollmentMedicalPayor.js.map